import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Canadian SIN validator following Single Responsibility Principle
 */
export class SinValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Canadian Social Insurance Number',
      pattern: /^\d{3}[\s-]?\d{3}[\s-]?\d{3}$/,
      length: 9
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/[\s-]/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'SIN format must be XXX XXX XXX or XXX-XXX-XXX or XXXXXXXXX'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/[\s-]/g, '');
    
    // Luhn algorithm for SIN
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      let digit = parseInt(cleanId[i]);
      
      if (i % 2 === 1) { // Even positions (0-indexed)
        digit *= 2;
        if (digit > 9) {
          digit = Math.floor(digit / 10) + (digit % 10);
        }
      }
      
      sum += digit;
    }

    if (sum % 10 !== 0) {
      return ValidationResult.invalid('Invalid SIN checksum');
    }

    return ValidationResult.valid('Valid SIN');
  }
}